import { UserProfile } from '@/types/user';

export function getUserDisplayName(user?: UserProfile | null) {
  const fullName = user?.fullName || user?.userName || `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
  return fullName || user?.email || 'User';
}

export function getUserRoleName(user?: UserProfile | null) {
  return user?.role?.name || user?.userRoles?.[0]?.roleName || user?.roles?.[0]?.name || 'User';
}

export function getUserAvatar(user?: UserProfile | null) {
  return user?.avatar;
}

export function getUserInitial(user?: UserProfile | null) {
  return getUserDisplayName(user).charAt(0).toUpperCase();
}
